import ApiService from '../service/ApiService';

let moduleApi = {};
let moduleName = "dot_kham";

moduleApi.listDotKham = (cardCode) => {
    let api = {
        module: moduleName,
        type: "list",
        value: {
            filters: "maDangKy=" + cardCode
        }
    };
    return ApiService(api);
};

moduleApi.chiTietLanKham = (idDotKhamChuaBenh, cardCode, hiddenMessage) => {
    let api = {
        module: moduleName,
        type: "get_chi_phi_by_id_dot_kham_chua_benh",
        params: { idDotKhamChuaBenh: idDotKhamChuaBenh, cardCode: (cardCode ? cardCode : '') },
        message: {
          success: "hidden",
          error: (hiddenMessage ? "hidden" : '')
        },
    };
    return ApiService(api);
};

moduleApi.requestOtp = (cardCode) => {
    let api = {
      module: moduleName,
      type: "requestOtp", //function mushroom
      value: {
        "cardCode": cardCode
      }
    };
    return ApiService(api);
  };
  
  
  moduleApi.validateOtp = (cardCode, otp) => {
    let api = {
      module: moduleName,
      type: "validateOtp",
      value: {
        "cardCode": cardCode,
        "otp": otp
      }
    };
    return ApiService(api);
  };


export default moduleApi;
